import React, { useState } from "react";
import {
  Grid,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Box,
  Chip,
  IconButton,
  LinearProgress,
  Stack,
  Paper,
  Container,
  styled,
  alpha,
  Button,
  Avatar,
  useTheme,
} from "@mui/material";
import {
  MenuBook as BookIcon,
  Handshake as HelpingHandIcon,
  Description as FileTextIcon,
  CalendarMonth as CalendarIcon,
  Assignment as ClipboardIcon,
  Chat as ChatIcon,
} from "@mui/icons-material";
import LessonGeneration from "./LessonGeneration";

import CreateClassDialog from "./CreateClassDialog";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import DashboardToolsShortcuts from "./DashboardToolsShortcuts";

import QuestionAnswerIcon from "@mui/icons-material/QuestionAnswer";
import AlternateEmailIcon from "@mui/icons-material/AlternateEmail";
import SchoolIcon from "@mui/icons-material/School";
import MenuOpenIcon from "@mui/icons-material/MenuBook";
import NotesIcon from "@mui/icons-material/Notes";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DashboardTeacherShortcuts from "./DashboardTeacherShortcuts";
import CurrentSection from "./CurrentSection";

import PeopleIcon from "@mui/icons-material/People";

import StartPageFAQSection from "../StartPageFAQSection";
import { InstructionItem } from "./functions";
import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import GroupsIcon from "@mui/icons-material/Groups";
import MessageIcon from "@mui/icons-material/Message";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import { Link as MuiLink } from "@mui/material";

import ImageSearchIcon from "@mui/icons-material/ImageSearch";
import EventNoteIcon from "@mui/icons-material/EventNote";
import PowerPointIcon from "./PowerPointIcon";
import { Grading as GradingIcon } from "@mui/icons-material";

import ContactForm from "../ContactForm";
import LessonBankDialog from "./LessonBankDialog";
import { TableChart as TableChartIcon } from "@mui/icons-material";

import RateReviewIcon from "@mui/icons-material/RateReview";
import { useNavigate, Link } from "react-router-dom";
import { getStyles } from "../index";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import PhotoLibraryIcon from "@mui/icons-material/PhotoLibrary";
import DashboardIcon from "@mui/icons-material/Dashboard";
import QuizBank from "./QuizBank";
import FlashcardsBank from "./FlashcardsBank";
import ImageBank from "./ImageBank";

import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import CastForEducationIcon from "@mui/icons-material/CastForEducation";
import QuizIcon from "@mui/icons-material/Quiz";
import ViewAgendaIcon from "@mui/icons-material/ViewAgenda";
import ImageIcon from "@mui/icons-material/Image";

import CalculateIcon from "@mui/icons-material/Calculate";
import GradientDesign from "./GradientDesign";
import {
  HeroSection,
  StyledCard,
  CardMediaStyled,
  IconWrapper,
  CardContentStyled,
} from "../StyledComponents";

const topAIAssistants = [
  {
    name: "SFI-lärare",
    description:
      "Simulera rollspel med Erik som talar både svenska och arabiska",
    usage: "2,453",
    rating: "4.8",
    icon: CalculateIcon,
    iconbg: "#2196f3",
    path: "/app/chat/iZgt6mAdqIpt7pLjRS5w",
    img: "https://firebasestorage.googleapis.com/v0/b/studeraai.appspot.com/o/teacherImages%2FZ6BLSMsm38Un5mgW0O6Z3TToHq12%2Fsve.jpg?alt=media&token=58949dc2-887c-4453-b128-b7a55468ca8e",
  },
  {
    name: "Matematik-hjälpen",
    description: "Specialiserad på att förklara matematiska koncept",
    usage: "3,724",
    rating: "4.7",
    icon: CalculateIcon,
    iconbg: "#2196f3",
    path: "/app/chat/X6KLiiwYT6UJXaGYHBQ2",
    img: "https://firebasestorage.googleapis.com/v0/b/studeraai.appspot.com/o/misc%2Fl%C3%A4rare%2Fmatte.png?alt=media&token=83f93ce6-8c87-43ec-857a-c24b34457cb8",
  },
];

const videoItems = [
  // {
  //   icon: AutoFixHighIcon,
  //   text: "Generera videoklipp",
  //   //iconbg: "linear-gradient(135deg, #3fa1f2 0%, #2d96ef 100%)",
  //   iconbg: "linear-gradient(135deg, rgb(38 16 83) 0%, rgb(55 7 156) 100%)",
  //   href: "#lektioner",
  //   size: 6,
  //   description:
  //     "Generera, redigera, spara och skriv ut lektioner och pedagogiskt material.",
  // },
  // {
  //   icon: CastForEducationIcon,
  //   //iconbg: "linear-gradient(135deg, #6fb8f5 0%, #52a9f2 100%)",
  //   iconbg: "linear-gradient(135deg, rgb(38 16 83) 0%, rgb(55 7 156) 100%)",
  //   text: "Videobanken",
  //   href: "#hjalpmedel",
  //   size: 6,
  //   description:
  //     "Se vad våra användare har genererat. Skriv ut eller redigera utifrån egna behov.",
  // },
];

const navItems = [
  {
    icon: AutoFixHighIcon,
    text: "Generera lektioner",
    //iconbg: "linear-gradient(135deg, #3fa1f2 0%, #2d96ef 100%)",
    iconbg:
      "linear-gradient(135deg, rgb(109, 49, 237) 0%, rgb(129, 76, 241) 100%)",
    href: "#lektioner",
    size: 6,
    description:
      "Generera, redigera, spara och skriv ut lektioner och pedagogiskt material.",
  },
  {
    icon: CastForEducationIcon,
    //iconbg: "linear-gradient(135deg, #6fb8f5 0%, #52a9f2 100%)",
    iconbg:
      "linear-gradient(135deg, rgb(147, 102, 243) 0%, rgb(167, 132, 245) 100%)",
    text: "Lektionsbanken",
    href: "#hjalpmedel",
    size: 6,
    description:
      "Utvalda lektioner för olika ämen, årskurser och teman. Skriv ut eller redigera utifrån egna behov.",
  },

  {
    icon: QuizIcon,
    iconbg: "linear-gradient(135deg, #f23fc4 0%, #f466d1 100%)",
    text: "Generera quiz",
    href: "#chatbotar",
    size: 6,
    description:
      "Generera prov/quiz baserat på valfritt ämne. Redigera, dela, skriv ut eller spara.",
  },
  {
    icon: DashboardIcon,
    iconbg: "linear-gradient(135deg, #f570d5 0%, #f789dd 100%)",
    text: "Quiz-banken",
    href: "#chatbotar",
    size: 6,
    description:
      "Utvalda quiz/prov för olika ämen, årskurser och teman. Skriv ut eller redigera utifrån egna behov.",
  },

  {
    icon: ViewAgendaIcon,
    iconbg: "linear-gradient(135deg, #f2793f 0%, #f49666 100%)",
    text: "Generera flashcards",
    href: "#chatbotar",
    size: 6,
    description:
      "Generera flashcards baserat på valfritt ämne. Redigera, dela, skriv ut eller spara.",
  },

  {
    icon: ViewAgendaIcon,

    iconbg: "linear-gradient(135deg, #f7a579 0%, #f8b898 100%)",
    text: "Flashcards-banken",
    href: "#chatbotar",
    size: 6,
    description:
      "Utvalda flashcards för olika ämen, årskurser och teman. Skriv ut eller redigera utifrån egna behov.",
  },

  {
    icon: AddPhotoAlternateIcon,
    iconbg: "linear-gradient(135deg, #3f9ff2 0%, #66b4f4 100%)",
    text: "Generera bilder",
    href: "#chatbotar",
    size: 6,
    description:
      "Generera bilder utifrån dina instruktioner. Eget arkiv och möjlighet att ladda ned.",
  },
  {
    icon: PhotoLibraryIcon,

    iconbg: "linear-gradient(135deg, #3f9ff2 0%, #66b4f4 100%)",
    text: "Bildbanken",
    href: "#chatbotar",
    size: 6,
    description:
      "Ta del av vårt expansiva akriv av AI-genererade bilder. Ladda ned helt gratis.",
  },

  {
    icon: ImageSearchIcon,
    iconbg: "#6396df",

    text: "Bildanalys",
    href: "#exempel",
    size: 4,
    description:
      "Ladda upp valfri bild och få en analys/förklaring av dess innehåll.",
  },
  {
    icon: EventNoteIcon,
    iconbg: "#6396df",

    text: "Lektionsplanering",
    href: "#planering",
    size: 4,
    description:
      "Generera en lektionsplanering utifrån valfritt ämne. Anpassa och spara.",
  },
  {
    icon: PowerPointIcon,
    iconbg: "#6396df",

    text: "PowerPoint",
    href: "#bedomning",
    size: 4,
    description:
      "Generera PowerPoints samt tillhörande bilder på nolltid. Exportera som PPTX.",
  },

  {
    icon: NotesIcon,
    iconbg: "#6396df",
    path: "/app/fraga-ai?p=vocabulary",
    text: "Skapa begreppslista",
    href: "#bedomning",
    size: 3,
    description:
      "Generera begreppslista inom valfritt ämne, i valfritt format.",
  },
  {
    icon: AlternateEmailIcon,
    iconbg: "#6396df",
    path: "/app/fraga-ai?p=email",
    text: "Skriv e-post",
    href: "#bedomning",
    size: 3,
    description: "Generera ett email eller svara på ett email.",
  },

  {
    icon: MenuOpenIcon,
    iconbg: "#6396df",
    path: "/app/kurser",
    text: "Skapa en egen kurs",
    href: "#bedomning",
    size: 3,
    description: "Generera kurs om valfritt ämne & studera i egen takt.",
  },

  {
    icon: MenuOpenIcon,
    iconbg: "#6396df",
    path: "/app/fraga-ai?p=explain",

    text: "Förklara för mig",
    href: "#bedomning",
    size: 3,
    description: "Få vad som helst förklarat i önskat format.",
  },

  {
    icon: PeopleIcon,
    iconbg: "#6396df",
    path: "/app/fraga-ai?p=roleplay",

    text: "Rollspel",
    href: "#bedomning",
    size: 3,
    description: "Låt en chatbot spela en anpassad roll som du väljer.",
  },

  {
    icon: QuestionAnswerIcon,
    iconbg: "#6396df",

    text: "Debatt",
    href: "#bedomning",
    path: "/app/fraga-ai?p=debate",
    size: 3,
    description:
      "Simulera en debatt om valfritt ämne och välj position för eller emot.",
  },

  {
    icon: PersonAddAltIcon,
    iconbg: "#30508a",

    text: "Skapa AI-assistent",
    href: "#bedomning",
    size: 6,
    description: "Och anpassa hur AI-assistenten ska svara.",
  },
  {
    icon: GroupsIcon,
    iconbg: "#903f6a",

    text: "Alla AI-assistenter",
    href: "#bedomning",
    size: 6,
    description: "Utvalda AI-assistenter du kan använda.",
  },
  {
    icon: MessageIcon,
    iconbg: "#903f3f",
    text: "Fråga AI — Vår egen ChatGPT",
    href: "#bedomning",
    size: 6,
    description:
      "Anpassad för lärare & elever. Skapa egna prompts och exportera meddelanden.",
  },

  {
    icon: GradingIcon,
    iconbg: "#4642a0",

    text: "Betygsätt en text",
    href: "#planering",
    size: 4,
    description:
      "Välj en förvald bedömningsmatris eller skapa en egen. Skriv in texten och få en preliminär bedömning. Exportera som Word- eller PDF. Radera alla data när du vill.",
  },

  {
    icon: RateReviewIcon,
    iconbg: "#4642a0",

    text: "Formativ bedömning",
    href: "#bedomning",
    size: 4,
    description:
      "Välj en förvald bedömningsmatris eller skapa en egen. Skriv in texten och få en preliminär bedömning. Exportera som Word- eller PDF. Radera alla data när du vill.",
  },

  {
    icon: TableChartIcon,
    iconbg: "linear-gradient(135deg, #6d31ed87 0%, #6d31ed 100%)",

    text: "Bedömningsmatriser",
    href: "#bedomning",
    size: 4,
    description: "Upptäck verktyg som förenklar din undervisning",
  },

  // Hjälpmedel elever

  {
    icon: GradingIcon,
    iconbg: "#6396df",
    path: "/app/uppsats/ny",
    text: "Betygsätt min text",
    href: "#bedomning",
    size: 3,
    description: "Betygsätt din text utifrån en bedömningsmatris.",
  },

  {
    icon: GradingIcon,
    iconbg: "#6396df",
    path: "/app/fraga-ai",
    text: "Fråga AI",
    href: "/app/hej",
    size: 3,
    description: "Få hjälp med läxor, idéer och svar på dina frågor.",
  },
  {
    icon: ImageSearchIcon,
    iconbg: "#6396df",
    path: "/app/vision",

    text: "Bildanalys",
    href: "#exempel",
    size: 3,
    description:
      "Ladda upp valfri bild och få en analys/förklaring av dess innehåll.",
  },
  {
    icon: NotesIcon,
    iconbg: "#6396df",
    path: "/app/fraga-ai?p=vocabulary",
    text: "Skapa begreppslista",
    href: "#bedomning",
    size: 3,
    description:
      "Generera begreppslista inom valfritt ämne, i valfritt format.",
  },
  {
    icon: AlternateEmailIcon,
    iconbg: "#6396df",
    path: "/app/fraga-ai?p=email",
    text: "Skriv e-post",
    href: "#bedomning",
    size: 3,
    description: "Generera ett email eller svara på ett email.",
  },

  {
    icon: MenuOpenIcon,
    iconbg: "#6396df",
    path: "/app/kurser",
    text: "Skapa en egen kurs",
    href: "#bedomning",
    size: 3,
    description: "Generera kurs om valfritt ämne & studera i egen takt.",
  },

  {
    icon: MenuOpenIcon,
    iconbg: "#6396df",
    path: "/app/fraga-ai?p=explain",

    text: "Förklara för mig",
    href: "#bedomning",
    size: 3,
    description: "Få vad som helst förklarat i önskat format.",
  },

  {
    icon: PeopleIcon,
    iconbg: "#6396df",
    path: "/app/fraga-ai?p=roleplay",

    text: "Rollspel",
    href: "#bedomning",
    size: 3,
    description: "Låt en chatbot spela en anpassad roll som du väljer.",
  },

  {
    icon: QuestionAnswerIcon,
    iconbg: "#6396df",

    text: "Debatt",
    href: "#bedomning",
    path: "/app/fraga-ai?p=debate",
    size: 3,
    description:
      "Simulera en debatt om valfritt ämne och välj position för eller emot.",
  },

  {
    icon: SchoolIcon,
    iconbg: "#6396df",

    text: "Gamla högskoleprov",
    path: "/app/hogskoleprov",
    href: "#bedomning",
    size: 3,
    description: "Plugga på gamla högskoleprov eller skapa eget med AI.",
  },

  {
    icon: PowerPointIcon,
    iconbg: "#6396df",
    path: "/app/generera-powerpoint",

    text: "Generera PowerPoint",
    href: "#bedomning",
    size: 3,
    description: "Skapa engagerande presentationer på några sekunder.",
  },
];

const gradingItems = [
  {
    icon: GradingIcon,
    iconbg: "linear-gradient(to right, #8B5CF6, #865be7)",

    text: "Betygsätt en text",
    href: "#planering",
    size: 4,
    description: "Bedöm och betygsätt en text.",
  },

  {
    icon: TableChartIcon,
    iconbg: "linear-gradient(to right, #8B5CF6, #865be7)",

    text: "Mina bedömningar",
    href: "#bedomning",
    size: 4,
    description: "Se och hantera dina bedömningar",
  },

  {
    icon: TableChartIcon,
    iconbg: "linear-gradient(to right, #8B5CF6, #865be7)",

    text: "Skapa ny bedömningsmatris",
    href: "#bedomning",
    size: 4,
    description: "Skapa nya matriser för bedömning.",
  },

  {
    icon: TableChartIcon,
    iconbg: "linear-gradient(to right, #8B5CF6, #865be7)",

    text: "Mina bedömningsmatriser",
    href: "#bedomning",
    size: 4,
    description: "Hantera dina bedömningsmatriser.",
  },

  {
    icon: TableChartIcon,
    iconbg: "linear-gradient(to right, #8B5CF6, #865be7)",

    text: "Skapa ny klass",
    href: "#bedomning",
    size: 4,
    description: "Organisera dina bedömningar.",
  },
  {
    icon: TableChartIcon,
    iconbg: "linear-gradient(to right, #8B5CF6, #865be7)",

    text: "Mina klasser",
    href: "#bedomning",
    size: 4,
    description: "Översikt över dina klasser",
  },
];

const StartPage = ({ user, role }) => {
  const theme = useTheme();

  const [open, setOpen] = useState(false);
  const [openFlashcardsBank, setOpenFlashcardsBank] = useState(false);
  const [showLessonGeneration, setShowLessonGeneration] = useState(false);

  const [openImageBank, setOpenImageBank] = useState(false);
  const [isCreateClassDialogOpen, setIsCreateClassDialogOpen] = useState(false);
  const [openLessonBank, setOpenLessonBank] = useState(false);
  const navigate = useNavigate();

  const styles = getStyles(theme);

  const handleClassCreated = async (newClass) => {
    navigate(`/app/klasser/${newClass.id}`);

    setIsCreateClassDialogOpen(false);
  };

  const handleNavItemClick = (text, path) => {
    if (path) {
      navigate(path);
      return;
    }

    switch (text) {
      case "Quiz-banken":
        setOpen(true); // Opens QuizBank
        break;
      case "Exempel på quiz":
        // Handle quiz examples
        console.log("Opening quiz examples");
        break;
      case "Generera lektioner":
        navigate("/app/lektioner"); // Navigate to the new route instead of using state
        break;

      case "Lektionsbanken":
        setOpenLessonBank(true);
        break;
      case "Generera bilder":
        navigate("/app/generera-bild");
        break;
      case "Generera flashcards":
        navigate("/app/flashcards");
        break;
      case "Generera quiz":
        navigate("/app/quiz");

        break;

      case "Bildbanken":
        setOpenImageBank(true);
        break;

      case "Flashcards-banken":
        setOpenFlashcardsBank(true);
        break;

      case "Formativ bedömning":
        navigate("/app/bedomning/formativ-bedomning");
        break;

      case "Betygsätt en text":
        navigate("/app/uppsats/ny");
        break;

      case "Mina bedömningar":
        navigate("/app/uppsatser");
        break;

      case "Skapa ny bedömningsmatris":
        navigate("/app/matris/ny");
        break;

      case "Mina bedömningsmatriser":
        navigate("/app/matris/mina");
        break;

      case "Skapa ny klass":
        setIsCreateClassDialogOpen(true);

        break;

      case "Mina klasser":
        navigate("/app/klasser");
        break;

      case "Skapa AI-assistent":
        navigate("/app/larare");
        break;

      case "Alla AI-assistenter":
        navigate("/app/personal");
        break;

      case "Fråga AI — Vår egen ChatGPT":
        navigate("/app/fraga-ai");
        break;

      case "Bildanalys":
        navigate("/app/vision");
        break;

      case "Lektionsplanering":
        navigate("/app/lektioner/lektionsplan");
        break;

      case "PowerPoint":
        navigate("/app/generera-powerpoint");
        break;

      // Add cases for other nav items
      default:
        console.log("Clicked:", text);
    }
  };

  if (showLessonGeneration) {
    return (
      <LessonGeneration
        onBack={() => setShowLessonGeneration(false)}
        role={role}
        theme={theme}
        user={user}
        styles={styles}
      />
    );
  }

  return (
    <>
      <Box
        sx={{
          bgcolor: "background.default",
          minHeight: "100vh",

          mt: 3.5,
        }}
      >
        <HeroSection elevation={0} sx={{ display: "none" }}>
          <Container maxWidth="lg">
            <Typography
              variant="h2"
              component="h1"
              sx={{
                fontWeight: 500,
                textAlign: "center",

                fontSize: "2rem",
              }}
            >
              Vad vill du göra idag?
            </Typography>
            <Typography
              variant="h5"
              component="h2"
              sx={{
                fontWeight: 400,
                textAlign: "center",
                opacity: 0.9,
                maxWidth: "800px",
                mx: "auto",
                display: "none",
              }}
            >
              Vad vill du göra just nu?
            </Typography>
          </Container>
        </HeroSection>
        <Box sx={{ display: "block" }}>
          <GradientDesign
            user={user}
            styles={styles}
            theme={theme}
            role={role}
          />
        </Box>
        <Box sx={{ mb: 5, mt: "-48px", display: "none" }}>
          <CurrentSection user={user} theme={theme} styles={styles} />
        </Box>
        <Container maxWidth="lg" sx={{ padding: "0px !important" }}>
          <Grid container spacing={3}>
            {/* First section - Generate New */}
            <Grid item xs={12} sm={6} md={6} sx={{ display: "none" }}>
              <Typography
                variant="h4"
                component="h2"
                sx={{
                  textAlign: "center",
                  mb: 2,
                  fontWeight: 600,
                  color: theme.palette.text.primary,
                  fontSize: "2rem",
                }}
              >
                Generera nytt
              </Typography>
              <Box
                sx={{
                  textAlign: "center",
                  width: { xs: "100%", md: "70%" },
                  margin: "0 auto",
                }}
              >
                <Typography
                  variant="subtitle"
                  sx={{
                    textAlign: "center",
                    color: "text.secondary",
                    fontSize: "1rem",
                    fontWeight: "500",
                  }}
                >
                  Generera helt nytt material. Spara i eget arkiv. Dela med
                  elever & vänner. Eller skriv ut.
                </Typography>
              </Box>

              <Box sx={{ textAlign: "center" }}>
                <KeyboardDoubleArrowDownIcon
                  sx={{ fontSize: "2rem", color: "text.secondary", mt: 2 }}
                />
              </Box>
            </Grid>
            <Grid item xs={12} sm={6} md={6} sx={{ display: "none" }}>
              <Typography
                variant="h4"
                component="h2"
                sx={{
                  textAlign: "center",
                  mb: 2,
                  fontWeight: 600,
                  color: theme.palette.text.primary,
                  fontSize: "2rem",
                }}
              >
                Utforska våra arkiv
              </Typography>
              <Box
                sx={{
                  textAlign: "center",
                  width: { xs: "100%", md: "70%" },
                  margin: "0 auto",
                }}
              >
                <Typography
                  variant="subtitle"
                  sx={{
                    textAlign: "center",
                    color: "text.secondary",
                    fontSize: "1rem",
                    fontWeight: "500",
                  }}
                >
                  Hittar du lektioner, quiz eller flashcards du gillar? Spara i
                  ditt eget arkiv och redigera fritt.
                </Typography>
              </Box>
              <Box sx={{ textAlign: "center" }}>
                <KeyboardDoubleArrowDownIcon
                  sx={{ fontSize: "2rem", color: "text.secondary", mt: 2 }}
                />
              </Box>{" "}
            </Grid>
            {navItems
              .slice(role === "student" ? 2 : 0, 8)
              .map((item, index) => (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={item.size}
                  key={index}
                  sx={{ mb: 0.5, display: "none" }}
                >
                  <StyledCard
                    isLarge={item.size === 6}
                    onClick={() => handleNavItemClick(item.text, item?.path)}
                    sx={{ position: "relative" }}
                  >
                    <ChevronRightIcon
                      sx={{
                        color: "text.secondary",
                        position: "absolute",
                        right: 24,
                        top: "50%",
                        transform: "translateY(-50%)",
                        fontSize: 24,
                      }}
                    />
                    <CardMediaStyled isLarge={item.size === 6}>
                      <IconWrapper
                        sx={{
                          background: item.iconbg,
                          padding: "20px",
                          borderRadius: "50px",
                        }}
                      >
                        <item.icon
                          sx={{
                            fontSize: 44,
                            color: "white",
                          }}
                        />
                      </IconWrapper>
                    </CardMediaStyled>
                    <CardContentStyled
                      sx={{
                        paddingLeft: item.size === 6 ? 0 : undefined,
                        paddingTop: item.size === 3 ? 0 : undefined,
                        textAlign: item.size === 3 ? "center" : "left",
                      }}
                    >
                      <Box>
                        <Typography
                          variant="h5"
                          component="h2"
                          sx={{
                            mb: 0.7,
                            fontWeight: 600,
                            color: theme.palette.text.primary,
                            fontSize: "1.4rem",
                          }}
                        >
                          {item.text}
                        </Typography>
                        <Typography
                          variant="body1"
                          color="text.secondary"
                          sx={{
                            fontWeight: 400,
                            lineHeight: 1.6,
                            fontSize: "0.92rem",
                            width: { xs: "100%", md: "90%" },
                          }}
                        >
                          {item.description}
                        </Typography>
                      </Box>
                    </CardContentStyled>
                  </StyledCard>
                </Grid>
              ))}
            {videoItems.map((item, index) => (
              <Grid
                item
                xs={12}
                sm={6}
                md={item.size}
                key={index}
                sx={{ mb: 0.5 }}
              >
                <StyledCard
                  isLarge={item.size === 6}
                  onClick={() => handleNavItemClick(item.text, item?.path)}
                  sx={{
                    position: "relative",
                    pointerEvents: "none",
                    filter: "blur(3px)",
                  }}
                >
                  <ChevronRightIcon
                    sx={{
                      color: "text.secondary",
                      position: "absolute",
                      right: 24,
                      top: "50%",
                      transform: "translateY(-50%)",
                      fontSize: 24,
                    }}
                  />
                  <CardMediaStyled isLarge={item.size === 6}>
                    <IconWrapper
                      sx={{
                        background: item.iconbg,
                        padding: "20px",
                        borderRadius: "50px",
                      }}
                    >
                      <item.icon
                        sx={{
                          fontSize: 44,
                          color: "white",
                        }}
                      />
                    </IconWrapper>
                  </CardMediaStyled>
                  <CardContentStyled
                    sx={{
                      paddingLeft: item.size === 6 ? 0 : undefined,
                      paddingTop: item.size === 3 ? 0 : undefined,
                      textAlign: item.size === 3 ? "center" : "left",
                    }}
                  >
                    <Box>
                      <Typography
                        variant="h5"
                        component="h2"
                        sx={{
                          mb: 0.7,
                          fontWeight: 600,
                          color: theme.palette.text.primary,
                          fontSize: "1.4rem",
                        }}
                      >
                        {item.text}
                      </Typography>
                      <Typography
                        variant="body1"
                        color="text.secondary"
                        sx={{
                          fontWeight: 400,
                          lineHeight: 1.6,
                          fontSize: "0.92rem",
                          width: { xs: "100%", md: "90%" },
                        }}
                      >
                        {item.description}
                      </Typography>
                    </Box>
                  </CardContentStyled>
                </StyledCard>
              </Grid>
            ))}
            <Grid item xs={12} sx={{ display: "none" }}>
              <Box
                sx={{
                  mt: 10,
                  pt: 6,
                  pb: 8,
                  px: 4,
                  display: role === "student" ? "block" : "none",
                  background:
                    theme.palette.mode === "dark" ? "#1d2e3da3" : "#e4edfa",
                  borderRadius: 4,
                  position: "relative",
                  overflow: "hidden",
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    // background:
                    //   "radial-gradient(circle at 50% 50%, rgb(100 171 85 / 45%) 0%, #5ba54a2e 50%)", // Updated to use #4A90E2 with opacity
                    opacity: 0.5,
                  },
                }}
              >
                <Typography
                  variant="h4"
                  component="h2"
                  align="center"
                  sx={{
                    mb: 6,
                    fontWeight: 600,

                    position: "relative",
                  }}
                >
                  Hjälpmedel
                </Typography>
                <Grid container spacing={4}>
                  {navItems.slice(8, 17).map((item, index) => (
                    <Grid item xs={12} md={4} key={index}>
                      <Box
                        onClick={() =>
                          handleNavItemClick(item.text, item?.path)
                        }
                        sx={{
                          background: theme.palette.background.paper,
                          borderRadius: 3,
                          p: 4,
                          height: "100%",
                          cursor: "pointer",
                          position: "relative",
                          boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
                          transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                          "&:hover": {
                            transform: "translateY(-12px)",
                            boxShadow: "0 12px 32px rgba(0,0,0,0.12)",
                            "& .hover-line": {
                              width: "90%",
                              opacity: 0.8,
                            },
                          },
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            textAlign: "center",
                          }}
                        >
                          <Box
                            sx={{
                              background: item.iconbg,
                              p: 2,
                              borderRadius: 50,
                              display: "flex",
                              mb: 3,
                            }}
                          >
                            <item.icon sx={{ fontSize: 28, color: "white" }} />
                          </Box>
                          <Typography
                            variant="h5"
                            sx={{ fontWeight: 600, mb: 2 }}
                          >
                            {item.text}
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              color: "text.secondary",
                              mb: 3,
                              lineHeight: 1.7,
                            }}
                          >
                            {item.description}
                          </Typography>
                          <Box
                            className="hover-line"
                            sx={{
                              height: 3,
                              width: "50%",
                              background:
                                index === 0
                                  ? "linear-gradient(90deg, #8f96ff, transparent)"
                                  : "linear-gradient(90deg, #8f96ff, transparent)",
                              opacity: 0.4,
                              transition:
                                "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                            }}
                          />
                        </Box>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            </Grid>
            <Grid item xs={12} sx={{ display: "none" }}>
              <Box
                sx={{
                  mt: 10,
                  p: 0,
                  height: "auto", // Changed from fixed height to accommodate the toplist
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  overflow: "hidden",
                  borderRadius: 4,
                  bgcolor: "background.paper",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                }}
              >
                <Box
                  sx={{
                    width: { xs: "100%", md: "50%" },
                    p: 4,
                    background:
                      "linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)",
                    color: "white",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    position: "relative",
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background: "rgba(255,255,255,0.05)",
                      clipPath: "polygon(0 0, 100% 0, 70% 100%, 0% 100%)",
                    },
                  }}
                >
                  <Typography
                    variant="h3"
                    gutterBottom
                    sx={{ fontWeight: 700, position: "relative" }}
                  >
                    AI-assistenter
                  </Typography>
                  <Box sx={{ display: "none" }}>
                    <Box sx={{ mt: 7, position: "relative" }}>
                      <Typography variant="subtitle">
                        Skapa en helt egen AI-assistent och bestäm exakt hur den
                        ska bete sig utifrån dina elevers behov. Dela
                        assistenten med vänner eller elever.
                      </Typography>
                    </Box>

                    <Box sx={{ mt: 2, position: "relative" }}>
                      <Typography variant="subtitle">
                        Utmärkt för att lära sig mer om specifika ämnen samt öva
                        på språk i en lugn, trygg och stressfri miljö.
                      </Typography>
                    </Box>
                  </Box>
                  <Box sx={{ mt: 2, position: "relative" }}>
                    <Typography variant="subtitle">
                      Skapa hur många assistenter du vill. Alla konversationer
                      sparas i ditt eget arkiv och du kan radera alla
                      konversationer när du vill.
                    </Typography>
                  </Box>

                  {/* Toplist section */}
                  <Box sx={{ mt: "auto" }}>
                    <Typography
                      variant="h5"
                      gutterBottom
                      sx={{
                        fontWeight: 500,
                        fontSize: "1.1rem",
                        mb: 2,
                      }}
                    >
                      Populära exempel:
                    </Typography>
                    <Grid container spacing={3}>
                      {topAIAssistants.slice(0, 2).map((assistant, index) => (
                        <Grid item xs={12} md={6} key={index}>
                          <Box
                            onClick={() => navigate(assistant.path)}
                            sx={{
                              p: 2,
                              width: "100%",
                              borderRadius: 2,
                              cursor: "pointer !important",
                              bgcolor:
                                theme.palette.mode === "dark"
                                  ? "rgba(255,255,255,0.05)"
                                  : "rgb(255 255 255)",
                              transition: "all 0.3s ease-in-out", // Simplified from your cubic-bezier
                              position: "relative", // Added
                              zIndex: 1, // Added

                              "&:hover": {
                                transform: "translateY(-4px)",

                                boxShadow: "0 4px 12px rgba(0,0,0,0.05)",
                                zIndex: 2, // Added
                                "& .hover-line": {
                                  width: "100%",
                                  opacity: 0.8,
                                },
                              },
                            }}
                          >
                            <ChevronRightIcon
                              sx={{
                                color: "text.secondary",
                                position: "absolute",
                                right: 2,
                                top: "50%",
                                transform: "translateY(-50%)",
                                fontSize: 24,
                                display: "none",
                              }}
                            />
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                mb: 1,
                              }}
                            >
                              <Box
                                sx={{
                                  p: 0.5,
                                  borderRadius: 1,
                                  mr: 1,
                                }}
                              >
                                <Avatar src={assistant.img} />
                              </Box>
                              <Typography
                                variant="subtitle2"
                                sx={{
                                  fontWeight: 600,
                                  color:
                                    theme.palette.mode === "dark"
                                      ? "white"
                                      : "black",
                                }}
                              >
                                {assistant.name}
                              </Typography>
                            </Box>
                            <Typography
                              variant="caption"
                              sx={{
                                color:
                                  theme.palette.mode === "dark"
                                    ? "white"
                                    : "text.secondary",
                                display: "block",
                                mb: 1,
                              }}
                            >
                              {assistant.description}
                            </Typography>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              <Typography
                                variant="caption"
                                sx={{
                                  color:
                                    theme.palette.mode === "dark"
                                      ? "white"
                                      : "text.secondary",
                                  fontWeight: "500",
                                }}
                              >
                                {assistant.usage} användare
                              </Typography>
                              <Typography
                                variant="caption"
                                sx={{
                                  color: "primary.main",
                                  fontWeight: "400",
                                }}
                              >
                                {assistant.rating} ★
                              </Typography>
                            </Box>

                            <Box
                              className="hover-line"
                              sx={{
                                height: 3,
                                mt: 1,
                                width: "50%",
                                background:
                                  index === 0
                                    ? "linear-gradient(90deg, #966bf4, transparent)"
                                    : "linear-gradient(90deg, #966bf4, transparent)",
                                opacity: 0.4,
                                transition:
                                  "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                              }}
                            />
                          </Box>
                        </Grid>
                      ))}
                    </Grid>
                  </Box>

                  <Box sx={{ mt: 2, position: "relative", display: "none" }}>
                    <InstructionItem
                      text={"Välj bedömningsmatris"}
                      marginBottom={1}
                      color="white"
                      simple="true"
                    />
                    <InstructionItem
                      text={"Skriv in din text"}
                      marginBottom={1}
                      color="white"
                      simple="true"
                    />
                    <InstructionItem
                      text={"Få preliminär bedömning"}
                      marginBottom={1.5}
                      color="white"
                      simple="true"
                    />
                  </Box>
                </Box>
                <Box
                  sx={{
                    flex: 1,
                    p: 4,
                    bgcolor:
                      theme.palette.mode === "dark" ? "transparent" : "#fff",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {/* Original navigation items */}
                  <Grid container spacing={3} sx={{ mb: 4 }}>
                    {navItems.slice(17, 20).map((item, index) => (
                      <Grid item xs={12} key={index} sx={{ mt: 1 }}>
                        <Box
                          onClick={() =>
                            handleNavItemClick(item.text, item?.path)
                          }
                          sx={{
                            ...styles.freshBox,
                            background: theme.palette.background.paper,
                            borderRadius: 3,
                            p: 3,
                            height: "100%",
                            cursor: "pointer",
                            position: "relative",
                            boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                            transition: "all 0.3s ease",
                            "&:hover": {
                              transform: "translateY(-8px)",
                              boxShadow: "0 12px 28px rgba(0,0,0,0.12)",
                            },
                          }}
                        >
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                flex: 1,
                              }}
                            >
                              <Box
                                sx={{
                                  background: item.iconbg,
                                  p: 1.5,
                                  borderRadius: 50,
                                  height: 60,
                                  width: 60,
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                <item.icon
                                  sx={{ fontSize: 29, color: "white" }}
                                />
                              </Box>
                              <Box sx={{ flex: 1, ml: 2 }}>
                                <Typography
                                  variant="h6"
                                  sx={{ fontWeight: 600 }}
                                >
                                  {item.text}
                                </Typography>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    color: "text.secondary",
                                    mt: 0,
                                    fontSize: "1rem",
                                  }}
                                >
                                  {item.description}
                                </Typography>
                              </Box>
                            </Box>
                            <ChevronRightIcon
                              sx={{
                                color: theme.palette.text.secondary,
                                ml: 2,
                                fontSize: 24,
                              }}
                            />
                          </Box>
                        </Box>
                      </Grid>
                    ))}
                  </Grid>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} sx={{ display: "none" }}>
              <Box
                sx={{
                  mt: 10,
                  pt: 6,
                  pb: 8,
                  px: 4,

                  // background: "#e4f0e08a",
                  background: "#6d31ed17",
                  borderRadius: 4,
                  position: "relative",
                  overflow: "hidden",

                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    // background:
                    //   "radial-gradient(circle at 50% 50%, rgb(100 171 85 / 45%) 0%, #5ba54a2e 50%)", // Updated to use #4A90E2 with opacity
                    opacity: 0.5,
                  },
                }}
              >
                <Typography
                  variant="h4"
                  component="h2"
                  align="center"
                  sx={{
                    mb: 6,
                    fontWeight: 600,

                    position: "relative",
                  }}
                >
                  Bedömning
                </Typography>
                <Grid container spacing={4}>
                  {(role === "student"
                    ? gradingItems.slice(0, 4)
                    : gradingItems
                  ).map((item, index) => (
                    <Grid item xs={12} md={6} key={index}>
                      <Box
                        onClick={() =>
                          handleNavItemClick(item.text, item?.path)
                        }
                        sx={{
                          background: theme.palette.background.paper,
                          borderRadius: 3,
                          p: 4,
                          height: "100%",
                          cursor: "pointer",
                          position: "relative",
                          boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
                          transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                          "&:hover": {
                            transform: "translateY(-12px)",
                            boxShadow: "0 12px 32px rgba(0,0,0,0.12)",
                            "& .hover-line": {
                              width: "90%",
                              opacity: 0.8,
                            },
                          },
                        }}
                      >
                        {/* Add chevron with absolute positioning */}
                        <ChevronRightIcon
                          sx={{
                            color: "text.secondary",
                            position: "absolute",
                            right: 32,
                            top: "50%",
                            transform: "translateY(-50%)",
                            fontSize: 24,
                          }}
                        />

                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            mb: 3,
                          }}
                        >
                          <Box
                            sx={{
                              background: item.iconbg,
                              p: 2,
                              borderRadius: 50,
                              display: "flex",
                              mr: 2,
                            }}
                          >
                            <item.icon sx={{ fontSize: 28, color: "white" }} />
                          </Box>
                          <Typography variant="h5" sx={{ fontWeight: 600 }}>
                            {item.text}
                          </Typography>
                        </Box>
                        <Typography
                          variant="body1"
                          sx={{
                            color: "text.secondary",
                            mb: 3,
                            lineHeight: 1.7,
                            width: { xs: "100%", md: "90%" },
                          }}
                        >
                          {item.description}
                        </Typography>

                        <Box
                          className="hover-line"
                          sx={{
                            height: 3,
                            width: "50%",
                            background:
                              index === 0
                                ? "linear-gradient(90deg, #966bf4, transparent)"
                                : "linear-gradient(90deg, #966bf4, transparent)",
                            opacity: 0.4,
                            transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                          }}
                        />
                      </Box>
                    </Grid>
                  ))}
                </Grid>
                <Box sx={{ mt: 8, textAlign: "center" }}>
                  <Typography
                    variant="body1"
                    sx={{
                      color: "text.secondary",
                      maxWidth: "800px",
                      mx: "auto",
                      mb: 4,
                    }}
                  >
                    Observera att du får en preliminär bedömning som är objektiv
                    och konsekvent. Du kan enkelt anpassa bedömningen innan du
                    exporterar eller skriver ut.
                  </Typography>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12} sx={{ display: "none" }}>
              <Box
                sx={{
                  mt: 10,
                  display: role === "student" ? "none" : "block",
                  pt: 6,
                  pb: 8,
                  px: 4,
                  background:
                    theme.palette.mode === "dark" ? "#1d2e3da3" : "#e4edfa",
                  borderRadius: 4,
                  position: "relative",
                  overflow: "hidden",
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    // background:
                    //   "radial-gradient(circle at 50% 50%, rgb(100 171 85 / 45%) 0%, #5ba54a2e 50%)", // Updated to use #4A90E2 with opacity
                    opacity: 0.5,
                  },
                }}
              >
                <Typography
                  variant="h4"
                  component="h2"
                  align="center"
                  sx={{
                    mb: 6,
                    fontWeight: 600,

                    position: "relative",
                  }}
                >
                  Hjälpmedel
                </Typography>
                <Grid container spacing={4}>
                  {navItems.slice(8, 17).map((item, index) => (
                    <Grid item xs={12} md={4} key={index}>
                      <Box
                        onClick={() =>
                          handleNavItemClick(item.text, item?.path)
                        }
                        sx={{
                          background: theme.palette.background.paper,
                          borderRadius: 3,
                          p: 4,
                          height: "100%",
                          cursor: "pointer",
                          position: "relative",
                          boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
                          transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                          "&:hover": {
                            transform: "translateY(-12px)",
                            boxShadow: "0 12px 32px rgba(0,0,0,0.12)",
                            "& .hover-line": {
                              width: "90%",
                              opacity: 0.8,
                            },
                          },
                        }}
                      >
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            textAlign: "center",
                          }}
                        >
                          <Box
                            sx={{
                              background: item.iconbg,
                              p: 2,
                              borderRadius: 50,
                              display: "flex",
                              mb: 3,
                            }}
                          >
                            <item.icon sx={{ fontSize: 28, color: "white" }} />
                          </Box>
                          <Typography
                            variant="h5"
                            sx={{ fontWeight: 600, mb: 2 }}
                          >
                            {item.text}
                          </Typography>
                          <Typography
                            variant="body1"
                            sx={{
                              color: "text.secondary",
                              mb: 3,
                              lineHeight: 1.7,
                            }}
                          >
                            {item.description}
                          </Typography>
                          <Box
                            className="hover-line"
                            sx={{
                              height: 3,
                              width: "50%",
                              background:
                                index === 0
                                  ? "linear-gradient(90deg, #8f96ff, transparent)"
                                  : "linear-gradient(90deg, #8f96ff, transparent)",
                              opacity: 0.4,
                              transition:
                                "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                            }}
                          />
                        </Box>
                      </Box>
                    </Grid>
                  ))}
                </Grid>
              </Box>
            </Grid>

            <Grid item xs={12} sx={{ display: "none" }}>
              <Box
                sx={{
                  mt: 10,
                  pt: 6,
                  pb: 8,
                  px: 4,
                  background:
                    "linear-gradient(180deg, rgba(0,127,255,0.08) 0%, rgba(0,89,178,0) 100%)",
                  borderRadius: 4,
                  position: "relative",
                  overflow: "hidden",
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background:
                      "radial-gradient(circle at 50% 50%, rgba(0,127,255,0.1) 0%, transparent 50%)",
                    opacity: 0.5,
                  },
                }}
              >
                <Typography
                  variant="h4"
                  component="h2"
                  align="center"
                  sx={{
                    mb: 0,
                    fontWeight: 600,
                    position: "relative",
                  }}
                >
                  Vanliga frågor och svar
                </Typography>

                <Box sx={{ width: "100%" }}>
                  <StartPageFAQSection student={role === "student"} />
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} sx={{ display: "none" }}>
              <Box
                sx={{
                  mt: 6,
                  p: 0,
                  height: "450px",
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  overflow: "hidden",
                  borderRadius: 4,
                  bgcolor: "background.paper",
                  boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                }}
              >
                <Box
                  sx={{
                    flex: 1,
                    p: 4,
                    bgcolor:
                      theme.palette.mode === "dark" ? "transparent" : "#fff",
                  }}
                >
                  <Grid container spacing={3}>
                    <Grid item xs={12} sx={{ mt: 1 }}>
                      <Box sx={{ mt: 0, position: "relative" }}>
                        <InstructionItem
                          text={
                            "Opt-out från modellträning: Våra förfrågningar till AI-modeller används inte för att förbättra deras modeller."
                          }
                          marginBottom={2}
                          color="text.secondary"
                        />
                        <InstructionItem
                          text={
                            "Anonymisering av data: All data som skickas till AI anonymiseras och innehåller aldrig personlig information."
                          }
                          marginBottom={2}
                          color="text.secondary"
                        />

                        <InstructionItem
                          text={
                            "GDPR-säker plattform:  Vi följer strikt dataskyddslagstiftning för att skydda elever och lärare."
                          }
                          marginBottom={2}
                          color="text.secondary"
                        />

                        <InstructionItem
                          text={
                            "Ingen datadelning: Vi delar aldrig elev- eller lärardata med andra tredje parter."
                          }
                          marginBottom={2}
                          color="text.secondary"
                        />

                        <InstructionItem
                          text={
                            "Transparent datasäkerhet: Vi är öppna med hur din data hanteras och ger full kontroll till användaren."
                          }
                          marginBottom={2}
                          color="text.secondary"
                        />
                      </Box>
                    </Grid>
                  </Grid>
                </Box>
                <Box
                  sx={{
                    width: { xs: "100%", md: "50%" },
                    p: 4,
                    background:
                      "linear-gradient(180deg, #243B55 0%, #141E30 100%)",
                    color: "white",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    position: "relative",
                    "&::before": {
                      content: '""',
                      position: "absolute",
                      top: 0,
                      left: 0,
                      right: 0,
                      bottom: 0,
                      background: "rgba(255,255,255,0.05)",
                      clipPath:
                        "polygon(0 0, 100% 0, 100% 35%, 75% 35%, 75% 70%, 50% 70%, 50% 100%, 0 100%)",
                    },
                  }}
                >
                  <Typography
                    variant="h3"
                    gutterBottom
                    sx={{ fontWeight: 700, position: "relative" }}
                  >
                    GDPR
                  </Typography>

                  <Box sx={{ mt: 2, position: "relative" }}>
                    <Typography variant="subtitle">
                      Studera.ai är en GDPR-säker plattform där vi skyddar
                      elever och lärare genom strikt dataskydd.
                    </Typography>
                  </Box>

                  <Box sx={{ mt: 2, position: "relative" }}>
                    <Typography variant="subtitle">
                      All data anonymiseras och innehåller aldrig personlig
                      information. Vi delar aldrig elev- eller lärardata med
                      tredje parter.
                    </Typography>
                  </Box>

                  <Box sx={{ mt: 2, position: "relative" }}>
                    <Typography variant="subtitle">
                      Våra AI-förfrågningar används inte för modellträning, och
                      vi ger full insyn och kontroll över hur din data hanteras.
                    </Typography>
                  </Box>
                  <Box sx={{ mt: 5, position: "relative" }}>
                    <Typography variant="subtitle">
                      Har du frågor? Kontakta oss genom formuläret nedan.
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12}>
              <ContactForm disableAnimations={true} email={user.email} />
            </Grid>
          </Grid>

          <Box sx={{ mt: 5, display: "none" }}>
            <CurrentSection user={user} theme={theme} styles={styles} />
          </Box>

          <Box sx={{ textAlign: "center", mt: 7 }}>
            <Typography variant="subtitle" sx={{ color: "text.secondary" }}>
              © 2025 Studera.ai. Alla rättigheter förbehållna.
            </Typography>
          </Box>
        </Container>

        <QuizBank
          open={open}
          onClose={() => setOpen(false)}
          user={user}
          styles={styles}
          theme={theme}
        />

        <FlashcardsBank
          open={openFlashcardsBank}
          onClose={() => setOpenFlashcardsBank(false)}
          user={user}
          styles={styles}
          theme={theme}
        />
        <ImageBank
          open={openImageBank}
          onClose={() => setOpenImageBank(false)}
          user={user}
          styles={styles}
          theme={theme}
        />

        <CreateClassDialog
          open={isCreateClassDialogOpen}
          onClose={() => setIsCreateClassDialogOpen(false)}
          onClassCreated={handleClassCreated}
          userId={user.uid}
        />

        <LessonBankDialog
          open={openLessonBank}
          onClose={() => setOpenLessonBank(false)}
          user={user}
          styles={styles}
          theme={theme}
        />
      </Box>
    </>
  );
};

export default StartPage;
